export default __webpack_public_path__ + "static/media/tool-icon-ball-gun.bb6cbfde.svg";